// extracted by mini-css-extract-plugin
var _1 = "FoldedComments-module__container--bGAZA";
var _2 = "FoldedComments-module__folded--QFHUA";
var _3 = "FoldedComments-module__link--xAIuS";
export { _1 as "container", _2 as "folded", _3 as "link" }
